import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CookieBanner } from "@/components/CookieBanner";
import { LangProvider } from "@/i18n";
import Home from "@/pages/Home";
import Buchung from "@/pages/Buchung";
import Schulungen from "@/pages/Schulungen";
import Kontakt from "@/pages/Kontakt";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import Agb from "@/pages/Agb";
import Termin from "@/pages/Termin";
import Kalender from "@/pages/Kalender";
import Academy from "@/pages/Academy";
import PaymentResult from "@/pages/PaymentResult";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
        <LangProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Header />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/buchung" element={<Buchung />} />
                <Route path="/schulungen" element={<Schulungen />} />
                <Route path="/academy" element={<Academy />} />
                <Route path="/kontakt" element={<Kontakt />} />
                <Route path="/impressum" element={<Impressum />} />
                <Route path="/datenschutz" element={<Datenschutz />} />
                <Route path="/agb" element={<Agb />} />
                <Route path="/termin/:id" element={<Termin />} />
                <Route path="/kalender" element={<Kalender />} />
                <Route path="/payment/success" element={<PaymentResult kind="success" />} />
                <Route path="/payment/cancel" element={<PaymentResult kind="cancel" />} />
              </Routes>
            </main>
            <Footer />
            <CookieBanner />
            <Toaster position="top-center" />
          </BrowserRouter>
        </LangProvider>
      </ReactLenis>
    </div>
  );
}

export default App;
